import {
    getDownloadEverything as getDownloadEverythingImport,
    getRunClientsWithLogging as getRunClientsWithLoggingImport,
    getRunClientsWithDx9 as getRunClientsWithDx9Import,
    getShouldMinimizeToTray as getShouldMinimizeToTrayImport,
    getLanguage as getLanguageImport,
    getTestServers as getTestServersImport,
    getBackendSettings as getBackendSettingsImport,
    getLauncherType as getLauncherTypeImport,
} from './backend/selectors'
import {
    getLaunchDelay as getLaunchDelayImport,
    getAutoLaunchOnLogin as getAutoLaunchOnLoginImport,
    getAutoLaunchOnStartup as getAutoLaunchOnStartupImport,
    getLayout as getLayoutImport,
    getUiSettings as getUiSettingsImport,
} from './ui/selectors'
import { getText as getLocalizedText } from './localized/selectors'
import { getServers as getServersImport } from './servers/selectors'
import { getCounter as getCounterImport } from './display/selectors'

const backend = {
    getDownloadEverything: state => getDownloadEverythingImport(state.backend),
    getRunClientsWithLogging: state => getRunClientsWithLoggingImport(state.backend),
    getRunClientsWithDx9: state => getRunClientsWithDx9Import(state.backend),
    getShouldMinimizeToTray: state => getShouldMinimizeToTrayImport(state.backend),
    getLanguage: state => getLanguageImport(state.backend),
    getTestServers: state => getTestServersImport(state.backend),
    getBackendSettings: state => getBackendSettingsImport(state.backend),
    getLauncherType: state => getLauncherTypeImport(state.backend),
}

const ui = {
    getLaunchDelay: state => getLaunchDelayImport(state.ui),
    getAutoLaunchOnLogin: state => getAutoLaunchOnLoginImport(state.ui),
    getAutoLaunchOnStartup: state => getAutoLaunchOnStartupImport(state.ui),
    getLayout: state => getLayoutImport(state.ui),
    getUiSettings: state => getUiSettingsImport(state.ui),
}

const localized = {
    getText: state => getLocalizedText(state.localized),
}

const servers = {
    getServers: state => getServersImport(state.servers),
}

const display = {
    getCounter: state => getCounterImport(state.display),
}

// eslint-disable-next-line
export const selectors = {
    backend,
    ui,
    localized,
    servers,
    display,
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/selectors.js